module.exports = __webpack_public_path__ + "static/media/service-app-development.d8ed6044.png";